import * as angular from "angular";

angular
  .module('bringoz.admin.timekeeping', [
    'bringoz.admin.commons'
  ]);

